var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47.518px",
    height: "47.518px",
    viewBox: "0 -5.09 47.518 47.518",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ship",
    transform: "translate(-741.223 -359.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M750.1,389"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M773.7,397.1a7.41,7.41,0,0,1-3.2-.7,9.8,9.8,0,0,1-2.5-1.6c-.5-.4-1-.8-1.4-1.1a2.618,2.618,0,0,0-2.7,0c-.6.3-1.1.8-1.6,1.1a9.418,9.418,0,0,1-4,2,8.158,8.158,0,0,1-5.5-.8,10.13,10.13,0,0,1-2-1.4l-.4-.3a4.13,4.13,0,0,0-1.1-.7,2.354,2.354,0,0,0-2.3,0,3.6,3.6,0,0,0-1.2.8,16.666,16.666,0,0,1-3.1,2,.985.985,0,1,1-.8-1.8,14.193,14.193,0,0,0,2.6-1.7,8.636,8.636,0,0,1,1.6-1,4.462,4.462,0,0,1,4.2,0c.5.3,1,.6,1.4.9l.4.3a8.848,8.848,0,0,0,1.7,1.2,5.966,5.966,0,0,0,4.1.6,7.4,7.4,0,0,0,3.2-1.6,14.013,14.013,0,0,1,1.8-1.3,4.428,4.428,0,0,1,4.7,0c.6.4,1.2.8,1.7,1.2a11.56,11.56,0,0,0,2,1.3,5.647,5.647,0,0,0,3.6.4,6.726,6.726,0,0,0,2.8-1.4c.2-.2.4-.3.6-.5.3-.2.6-.5.9-.7a4.376,4.376,0,0,1,3.2-1,6.22,6.22,0,0,1,2.6.9l.9.6c.3.2.6.5.9.7a4.052,4.052,0,0,0,.9.5c.2.1.3.2.5.3a1.03,1.03,0,1,1-1,1.8.758.758,0,0,0-.4-.2,10.9,10.9,0,0,1-1.1-.6c-.3-.2-.7-.5-1-.7s-.5-.4-.8-.6a3.139,3.139,0,0,0-1.6-.6,2.805,2.805,0,0,0-1.9.7,5.548,5.548,0,0,0-.8.6,1.794,1.794,0,0,1-.7.5,8.53,8.53,0,0,1-3.6,1.7A8.752,8.752,0,0,1,773.7,397.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M773.7,392a7.41,7.41,0,0,1-3.2-.7,9.8,9.8,0,0,1-2.5-1.6,8.279,8.279,0,0,0-1.5-1.1,2.618,2.618,0,0,0-2.7,0c-.5.3-1,.7-1.6,1.1a9.418,9.418,0,0,1-4,2,8.24,8.24,0,0,1-5.5-.8,10.13,10.13,0,0,1-2-1.4l-.4-.3a4.13,4.13,0,0,0-1.1-.7,2.354,2.354,0,0,0-2.3,0,3.6,3.6,0,0,0-1.2.8,16.666,16.666,0,0,1-3.1,2,.985.985,0,1,1-.8-1.8,9.751,9.751,0,0,0,2.6-1.7,8.636,8.636,0,0,1,1.6-1,4.462,4.462,0,0,1,4.2,0,4.2,4.2,0,0,1,1.4.9l.4.3a8.848,8.848,0,0,0,1.7,1.2,5.966,5.966,0,0,0,4.1.6,7.4,7.4,0,0,0,3.2-1.6,20.277,20.277,0,0,1,1.8-1.3,4.428,4.428,0,0,1,4.7,0c.6.4,1.2.8,1.7,1.2a17.372,17.372,0,0,0,2,1.3,5.647,5.647,0,0,0,3.6.4,6.726,6.726,0,0,0,2.8-1.4c.2-.2.4-.3.6-.5.3-.2.6-.5.9-.7a4.376,4.376,0,0,1,3.2-1,6.22,6.22,0,0,1,2.6.9l.9.6c.3.2.6.5.9.7a4.052,4.052,0,0,0,.9.5c.2.1.3.2.5.3a1.03,1.03,0,1,1-1,1.8.758.758,0,0,0-.4-.2c-.4-.2-.7-.4-1.1-.6-.3-.2-.7-.5-1-.7s-.5-.4-.8-.6a3.139,3.139,0,0,0-1.6-.6,2.805,2.805,0,0,0-1.9.7c-.3.2-.5.4-.8.6a1.794,1.794,0,0,1-.7.5,8.53,8.53,0,0,1-3.6,1.7A3.645,3.645,0,0,1,773.7,392Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M750.1,389l33.2-1.5,2.6-9.1a1.02,1.02,0,0,0-.2-.9,1.234,1.234,0,0,0-.8-.4H743.8a1.05,1.05,0,0,0-.9.5.92.92,0,0,0,.1,1l7.1,10.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M780.8,375.2v-2a.945.945,0,0,0-1-1H752.6a1.2,1.2,0,0,0-1,.7l-.7,2.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M773.1,368.1v-7.4a.908.908,0,0,0-.3-.7.778.778,0,0,0-.8-.2l-4.9.3a.9.9,0,0,0-.9.9v7h6.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M778.2,370.2v-1.3a.945.945,0,0,0-1-1H756.7a1.2,1.2,0,0,0-1,.7l-.4,1.5h22.9Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.648913d635e1a47f13bc748be1e20106.svg";
export { ForwardRef as ReactComponent };